export default __webpack_public_path__ + "static/hub-library-062256f924d2d59a7d0060eba0ec548f.jpg";